import { render, staticRenderFns } from "./TextMessageEditorConfirmation.vue?vue&type=template&id=5fe10b66&"
import script from "./TextMessageEditorConfirmation.vue?vue&type=script&lang=js&"
export * from "./TextMessageEditorConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports